export default __webpack_public_path__ + "static/media/rate_th.3eca1f69.jpg";